import { Stack, Typography, TextField, Chip, Autocomplete } from '@mui/material'
import React from 'react'
import { useState } from 'react';

function MailsTxtField({ emails, width, setEmails, title }) {
    const [inputValue, setInputValue] = useState("");

    const handleKeyDown = (event) => {
        if (event.key === "Enter" && inputValue.trim() !== "") {
            event.preventDefault();
            if (!emails.includes(inputValue.trim())) {
                setEmails([...emails, inputValue.trim()]);
            }
            setInputValue("");
        }
    };

    const handleDelete = (emailToDelete) => {
        setEmails(emails.filter((email) => email !== emailToDelete));
    };

    return (
        <Stack sx={{ width: width ? width : 500 }}>
            <Typography style={{ color: "rgba(0, 0, 0, 0.8)", fontWeight: 500, fontSize: 12 }}  >{title} </Typography>
            <Autocomplete
                multiple
                freeSolo
                options={[]}
                value={emails}
                onChange={(event, newValue) => setEmails(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return (
                            <Chip
                                key={option}
                                label={option}
                                {...tagProps}
                                onDelete={() => handleDelete(option)}
                                sx={{ fontSize: 12 }}
                            />
                        );
                    })
                }
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" placeholder="Enter Email" onKeyDown={handleKeyDown}
                        sx={{ "& .MuiInputBase-root": { fontSize: 12 } }} />
                )}
            />
        </Stack>
    )
}

export default MailsTxtField